<div class="container">
    <div class="relayter-dark">
        <div class="relayter-dark-logo"></div>
    </div>

    <div class="content">
        <div class="login-card">
            @switch (state) {
                @case (ELoginState.INIT) {
                    <h1 class="hero text-center">Welcome to the Overmind</h1>
                    <p class="text-center grey">First things first, identify yourself</p>

                    <form [formGroup]="formGroup" class="login-form">
                        <nuc-form-field label="Email">
                            <nuc-input formControlName="email" placeholder="you@example.com" type="email" [autofocus]="true" [required]="true"></nuc-input>
                        </nuc-form-field>
                        <nuc-button-bar>
                            <nuc-button-primary
                                type="submit"
                                text="Continue"
                                [loading]="loading"
                                [disabled]="nextButtonDisabled"
                                (click)="onSubmitValid()"></nuc-button-primary>
                        </nuc-button-bar>
                    </form>
                }

                @case (ELoginState.SSO) {
                    <div class="login-status text-center">
                        <h1>Redirecting…</h1>
                        <p>Please wait while we send you to your identity provider.</p>
                    </div>
                }

                @default {
                    <div class="login-status text-center">
                        <h1>Login</h1>
                        <p>Not available yet.</p>
                    </div>
                }
            }
        </div>
    </div>
</div>
